import style from './style.module.scss'
import QuestionBlock from '../QuestionsBlock'
import { useEffect, useState } from 'react'
import { useUpdateSurveyMutation } from 'src/redux/Api/surveysApi'
import { ISurvey, SurveyStatus } from 'src/utils/Interfaces/survey.interface'
import Input from 'src/Components/Form/Input'
import Tabs from 'src/Components/Tabs'
import { motion, AnimatePresence, MotionConfig } from 'framer-motion'
import SettingsBlock from '../SettingsBlock'
import StylesBlock from '../StylesBlock'
import Select from 'src/Components/Form/Select'

interface Props {
  surveyData: ISurvey
}

const animate = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
}

const SurveySettings = ({ surveyData }: Props) => {
  const [updateSurvey] = useUpdateSurveyMutation()
  const [survey, setSurvey] = useState<ISurvey | null>(null)
  const [save, setSave] = useState(false)
  const [tabs, setTabs] = useState(0)

  useEffect(() => {
    if (surveyData) {
      setSurvey(surveyData)
    }
  }, [surveyData])

  useEffect(() => {
    if (JSON.stringify(surveyData) !== JSON.stringify(survey)) {
      setSave(true)
    } else {
      setSave(false)
    }
  }, [survey, surveyData])

  const saveHandler = () => {
    if (survey)
      updateSurvey({
        id: survey.id,
        name: survey.name,
        status: survey.status,
        settings: survey.settings,
        styles: survey.styles,
        questionsOrder: []
      })
  }

  const copyCodeToClipboard = async () => {
    if (!survey) return
    const text = `
    (function(w, c, r, s){
      var t = c.createElement('script');
      t.async = true;
      t.src = 'https://' + r + '/surveyrun';
      var h = c.getElementsByTagName('head')[0];
      h.appendChild(t);
      w.CRSSurveyID = s;
  })(window, document, 'stageserver.conversionrate.store', '${survey.clientId}')
    `
    await navigator.clipboard.writeText(text)
  }

  return (
    <div className={style.settings_block}>
      {survey && (
        <>
          <div className={style.left}>
            <div className="flx">
              <Input
                className="light border"
                name="name"
                label="Survey name"
                value={survey.name}
                onChange={(e) => setSurvey({ ...survey, name: e.target.value })}
              />
              <p style={{ margin: '10px 0' }}>Client: {survey.client.name}</p>
            </div>
            <Tabs name="survey_blocks" list={['Questions', 'Settings', 'Style']} onChange={setTabs} />

            <AnimatePresence initial={false}>
              <MotionConfig transition={{ duration: 0.3 }}>
                <div className={style.settings_content}>
                  {tabs === 0 && (
                    <motion.div variants={animate} initial={'hidden'} animate={'visible'} exit={'hidden'} className={style.questions}>
                      <QuestionBlock surveyId={survey.id} />
                    </motion.div>
                  )}
                  {tabs === 1 && (
                    <motion.div variants={animate} initial={'hidden'} animate={'visible'} exit={'hidden'} className={style.settings}>
                      <SettingsBlock data={survey.settings} update={(d) => setSurvey({ ...survey, settings: d })} />
                    </motion.div>
                  )}
                  {tabs === 2 && (
                    <motion.div variants={animate} initial={'hidden'} animate={'visible'} exit={'hidden'} className={style.style}>
                      <StylesBlock data={survey.styles} update={(d) => setSurvey({ ...survey, styles: d })} />
                    </motion.div>
                  )}
                </div>
              </MotionConfig>
            </AnimatePresence>
            <div className={style.bottom_control}>
              <Select<SurveyStatus>
                list={['ACTIVE', 'DRAFT', 'ENDED']}
                value={survey.status}
                onChange={(e) => {
                  setSurvey({ ...survey, status: e })
                }}
                label="Status"
                className={style.status_select}
              />
              <button className="btn" onClick={copyCodeToClipboard}>
                Copy install code
              </button>
            </div>
          </div>
        </>
      )}
      {save && (
        <button className={style.save_btn + ' btn'} onClick={saveHandler}>
          Save
        </button>
      )}
    </div>
  )
}

export default SurveySettings
